export const LOGIN_R = "LOGIN_R";
export const LOGIN_S = "LOGIN_S";
export const LOGIN_F = "LOGIN_F";

export const SIGNUP_R = "SIGNUP_R";
export const SIGNUP_S = "SIGNUP_S";
export const SIGNUP_F = "SIGNUP_F";

export const FORGOT_PASSWORD_S = "FORGOT_PASSWORD_S";
